import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ServiceType } from '@core/services/models/service.interface';
import { FormControlsModule } from '@shared/form-controls/form-controls.module';
import { InteractionsModule } from '@shared/interactions';

@Component({
    selector: 'rm-retail-media-parameters-agreement',
    standalone: true,
    imports: [CommonModule, FormControlsModule, InteractionsModule],
    templateUrl: './retail-media-parameters-agreement.component.html',
    styleUrls: ['./retail-media-parameters-agreement.component.scss']
})
export class RetailMediaParametersAgreementComponent {
    @Input()
    public control!: FormControl;

    protected ServiceType = ServiceType;
}
